<template>
  <div>
    <div>
      <v-breadcrumbs
        class="px-0"
        :items="[
          { title: '発達記録', href: '/child-development', color: 'primary' },
          { title: `クラス`, href: childClassId ? `/child-development/class/${year}/${childClassId}` : undefined, color: 'primary', disabled: !childClassId },
          { title: `${childName} (${year}年度)` },
        ]"
      ></v-breadcrumbs>
    </div>
    <page-title :value="`発達記録 - ${childName} (${year}年度)`" />
    <v-alert
      class="my-4"
      type="info"
      color="primary"
      variant="outlined"
      density="compact"
      style="font-size: 0.9rem"
    >
      評価基準<br/>
      ○：達成<br/>
      △：挑戦しようとしている様子が見られる<br/>
      &nbsp; - ：未達成<br/>
    </v-alert>
    <v-progress-linear v-if="isFetchingRecords" indeterminate color="primary" class="my-4" />
    <v-alert v-else-if="records.length === 0" type="info" color="primary" variant="outlined" density="compact" class="my-4">
      項目が設定されていません。
    </v-alert>
    <template v-else>
    <div
      class="table-wrapper"
    >
      <div class="records-table">
        <v-table
          class="table-wrapper"
          fixed-header
          height="calc(100vh - 200px)"
        >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                領域
              </th>
              <th class="text-left">
                項目
              </th>
              <th class="text-left observation-column">
                観察内容
              </th>
              <th class="text-left observation-column">
                観察のポイント/評価例
              </th>
              <th class="record-month">前年度に達成できた項目</th>
              <th class="record-month">4月</th>
              <th class="record-month">5月</th>
              <th class="record-month">6月</th>
              <th class="record-month">7月</th>
              <th class="record-month">8月</th>
              <th class="record-month">9月</th>
              <th class="record-month">10月</th>
              <th class="record-month">11月</th>
              <th class="record-month">12月</th>
              <th class="record-month">1月</th>
              <th class="record-month">2月</th>
              <th class="record-month">3月</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(r, i) in records"
              :key="i"
            >
              <td> {{ `${r.domain.name} ` }} </td>
              <td> {{ `${r.field} ` }} </td>
              <td class="observation-column"> {{ r.observationContent || '-' }} </td>
              <td class="observation-column"> {{ r.observationPoint || '-' }} </td>
              <td class="record-month-cell">
                <v-select
                  :items="selectOptions"
                  item-title="title"
                  item-value="value"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.prevYear"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'apr')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.apr"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'may')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.may"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'june')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.june"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'july')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.july"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'aug')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.aug"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'sept')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.sept"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'oct')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.oct"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'nov')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.nov"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'dec')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.dec"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'jan')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.jan"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'feb')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.feb"
                ></v-select>
              </td>
              <td class="record-month-cell">
                <v-select
                  v-if="shouldShowInput(r, 'mar')"
                  :items="selectOptions"
                  variant="outlined"
                  density="compact"
                  hide-details
                  v-model="r.milestone.mar"
                ></v-select>
              </td>
            </tr>
          </tbody>
        </template>
      </v-table>
      </div>
    </div>

    <div class="d-flex sticky-footer" style="width: 100%;">
      <v-spacer />
      <v-btn
        large
        variant="flat"
        color="primary"
        @click="updateRecords"
        :loading="isUpdating"
        :disabled="isUpdating"
      >保存</v-btn>
      <v-spacer />
    </div>

    </template>
  </div>
</template>
<script lang="ts">
import dayjs from 'dayjs';
import { defineComponent } from 'vue';
import PageTitle from '@/components/atoms/PageTitle.vue';

import { childDevelopmentChildModule } from '@/store/viewModules/child-development/childDevelopmentChildModule'
import { ChildDevelopmentResponse } from 'chaild-api/lib';

interface DataType {
  isFetchingRecords: boolean;
  childId?: number;
  year?: number;
  selectOptions: SelectOption[];
  isUpdating: boolean;
}

interface SelectOption {
  value: string | null;
  title: string;
}

export default defineComponent({
  components: {
    PageTitle
  },
  data: (): DataType => {
    return {
      isFetchingRecords: false,
      childId: undefined,
      year: undefined,
      selectOptions: [
        {
          value: 'done',
          title: '◯'
        },
        {
          value: 'close',
          title: '△'
        },
        {
          value: null,
          title: '-'
        },
      ],
      isUpdating: false,
    }
  },
  computed: {
    records() {
      return childDevelopmentChildModule.developmentRecords;
    },
    recordsWithMeta(): Array<{
      visibility: {
        may: boolean;
        june: boolean;
        july: boolean;
        aug: boolean;
        sept: boolean;
        oct: boolean;
        nov: boolean;
        dec: boolean;
        jan: boolean;
        feb: boolean;
        mar: boolean;
      };
    }> {
      return childDevelopmentChildModule.developmentRecords.map((r) => {
        return {

          visibility: {
            may: this.shouldShowInput(r, 'may'),
            june: this.shouldShowInput(r, 'june'),
            july: this.shouldShowInput(r, 'july'),
            aug: this.shouldShowInput(r, 'aug'),
            sept: this.shouldShowInput(r, 'sept'),
            oct: this.shouldShowInput(r, 'oct'),
            nov: this.shouldShowInput(r, 'nov'),
            dec: this.shouldShowInput(r, 'dec'),
            jan: this.shouldShowInput(r, 'jan'),
            feb: this.shouldShowInput(r, 'feb'),
            mar: this.shouldShowInput(r, 'mar'),
          }
        }
      })
    },
    child() {
      return childDevelopmentChildModule.child
    },
    childName(): string {
      if (this.child) {
        return `${this.child.lastName} ${this.child.firstName}`
      }
      return ''
    },
    childClassId(): number | undefined {
      if (this.child && this.child.nurseryClasses && this.child.nurseryClasses.length > 0) {
        return this.child.nurseryClasses[0].classId;
      }
      return undefined;
    },
  },
  methods: {
    shouldShowInput(record: ChildDevelopmentResponse, key: string) {
      // prevYearが'done'の場合は全ての月を非表示
      if (record.milestone.prevYear === 'done') {
        return false;
      }

      switch (key) {
        case 'apr':
          return true;
        case 'may':
          return !(record.milestone.apr === 'done');
        case 'june':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done'
          );
        case 'july':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done'
          );
        case 'aug':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done'
          );
        case 'sept':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done' ||
            record.milestone.aug === 'done'
          );
        case 'oct':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done' ||
            record.milestone.aug === 'done' ||
            record.milestone.sept === 'done'
          );
        case 'nov':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done' ||
            record.milestone.aug === 'done' ||
            record.milestone.sept === 'done' ||
            record.milestone.oct === 'done'
          );
        case 'dec':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done' ||
            record.milestone.aug === 'done' ||
            record.milestone.sept === 'done' ||
            record.milestone.oct === 'done' ||
            record.milestone.nov === 'done'
          );
        case 'jan':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done' ||
            record.milestone.aug === 'done' ||
            record.milestone.sept === 'done' ||
            record.milestone.oct === 'done' ||
            record.milestone.nov === 'done' ||
            record.milestone.dec === 'done'
          );
        case 'feb':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done' ||
            record.milestone.aug === 'done' ||
            record.milestone.sept === 'done' ||
            record.milestone.oct === 'done' ||
            record.milestone.nov === 'done' ||
            record.milestone.dec === 'done' ||
            record.milestone.jan === 'done'
          );
        case 'mar':
          return !(
            record.milestone.apr === 'done' ||
            record.milestone.may === 'done' ||
            record.milestone.june === 'done' ||
            record.milestone.july === 'done' ||
            record.milestone.aug === 'done' ||
            record.milestone.sept === 'done' ||
            record.milestone.oct === 'done' ||
            record.milestone.nov === 'done' ||
            record.milestone.dec === 'done' ||
            record.milestone.jan === 'done' ||
            record.milestone.feb === 'done'
          );
      }
      return true;
    },
    async listRecords() {
      if (this.childId && this.year) {
        this.isFetchingRecords = true;
        await childDevelopmentChildModule.listRecords({
          childId: this.childId,
          businessYear: this.year
        });
        this.isFetchingRecords = false;
      }
    },
    async getChild() {
      if (this.childId) {
        await childDevelopmentChildModule.getChild({
          childId: this.childId,
        });
      }
    },
    async updateRecords() {
      if (this.childId && this.year) {
        this.isFetchingRecords = true;
        this.isUpdating = true;
        await childDevelopmentChildModule.updateRecords({
          childId: this.childId,
          businessYear: this.year
        })
        await childDevelopmentChildModule.listRecords({
          childId: this.childId,
          businessYear: this.year
        });
        this.isFetchingRecords = false;
        this.isUpdating = false;
      }
    },
    formatDate(dateString: string | null) {
      if (!dateString) {
        return '不明';
      }
      return dayjs(dateString).format('YYYY-MM-DD HH:mm')
    },
    getAgeBasedonBirthdate(birthdate: string): number {
      const thisYear = dayjs();
      return thisYear.diff(birthdate, 'year');
    },
  },
  mounted() {
    const childId = this.$route.params.childId;
    if (childId) {
      this.childId = parseInt(childId as string, 10);
    }

    const year = this.$route.params.businessYear;
    if (year) {
      this.year = parseInt(year as string, 10);
    }

    this.listRecords();
    this.getChild();
  }
})
</script>
<style lang="scss" scoped>
.table-wrapper {
  overflow: auto;
  max-height: calc(100vh - 200px);
}
.records-table {
  width: 2400px;
}

// Sticky header
::v-deep thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}

// Column widths for sticky positioning
$col1-width: 100px; // 領域
$col2-width: 100px; // 項目
$col3-width: 200px; // 観察内容
$col4-width: 200px; // 観察のポイント

// Sticky start columns - 領域
::v-deep th:nth-child(1),
::v-deep td:nth-child(1) {
  position: sticky;
  start: 0;
  background-color: #fff;
  z-index: 1;
  min-width: $col1-width;
  width: $col1-width;
}

// Sticky start columns - 項目
::v-deep th:nth-child(2),
::v-deep td:nth-child(2) {
  position: sticky;
  start: $col1-width;
  background-color: #fff;
  z-index: 1;
  min-width: $col2-width;
  width: $col2-width;
}

// Sticky start columns - 観察内容
::v-deep th:nth-child(3),
::v-deep td:nth-child(3) {
  position: sticky;
  start: $col1-width + $col2-width;
  background-color: #fff;
  z-index: 1;
  min-width: $col3-width;
  width: $col3-width;
  white-space: pre-wrap;
  word-break: break-word;
}

// Sticky start columns - 観察のポイント/評価例
::v-deep th:nth-child(4),
::v-deep td:nth-child(4) {
  position: sticky;
  start: $col1-width + $col2-width + $col3-width;
  background-color: #fff;
  z-index: 1;
  min-width: $col4-width;
  width: $col4-width;
  white-space: pre-wrap;
  word-break: break-word;
  border-right: 2px solid #e0e0e0;
}

// Header cells in sticky columns need higher z-index (sticky both directions)
::v-deep thead th:nth-child(1),
::v-deep thead th:nth-child(2),
::v-deep thead th:nth-child(3),
::v-deep thead th:nth-child(4) {
  z-index: 3;
}

.record-month {
  width: 80px;
  min-width: 80px;
  text-align: center;
}
.record-month-cell {
  width: 80px;
  min-width: 80px;
}
.observation-column {
  max-width: 200px;
  white-space: pre-wrap;
  word-break: break-word;
}
.sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: white; 
  z-index: 5; 
  padding: 16px 0; 
  border-top: 1px solid #e0e0e0; 
}
</style>
